import Blog from './Blog';
export default Blog;



// WEBPACK FOOTER //
// ./src/client/js/view/routes/Blog/index.js